module.exports = __webpack_public_path__ + "img/video.6036cf28.svg";